export const isLocalEnvironment = process.env.NODE_ENV === "development";

export const envPrefix: string = "#{ENV_PREFIX}";

const trimmedPrefix = envPrefix.toString().trim();

export let environment = isLocalEnvironment
  ? "qa."
  : trimmedPrefix && !["prd", "prod"].includes(trimmedPrefix.toLowerCase())
  ? `${trimmedPrefix}.`
  : "";

environment = environment !== "." ? environment : "";

export const isProduction = environment === "";

const ENABLE_ATTESTATION_LOCAL = true;
const ENABLE_ATTESTATION_NON_PRODUCTION = true;
const ENABLE_ATTESTATION_PRODUCTION = true;

/**
 * Determines whether attestation checks should be on or off
 * @returns A boolean based on the above flags and the current environment
 */
function determineAttestation() {
  if (isLocalEnvironment) return ENABLE_ATTESTATION_LOCAL;
  if (isProduction) return ENABLE_ATTESTATION_PRODUCTION;
  return ENABLE_ATTESTATION_NON_PRODUCTION;
}

export const ENABLE_ATTESTATION = determineAttestation();

/* Amplitude Experiment deployment keys per environment.
 * Client-side public keys — they ship in the browser bundle, so committing them is fine.
 * Source: Amplitude > Experiment > Deployments > <deployment> > Deployment API Key.
 * Naming convention: members-portal-{qa,stg,prd}. */
const amplitudeDeploymentKeys = {
  qa: "client-VHHRfFS2UQ3Lfke7W79adp98OHpPBYWJ",
  stg: "client-Fg8NXyq6EHKiYdK34Pv8pS4t41UUnffZ",
  prd: "client-k7lLcQiSYu9QP5IFVOL7o3D2ci8RvsPM",
} as const;

function getAmplitudeDeploymentKey(): string {
  if (isLocalEnvironment) return amplitudeDeploymentKeys.qa;
  const trimmedPrefix = envPrefix.toString().trim();
  /* istanbul ignore next — branches reachable only after build-time token replacement */
  if (trimmedPrefix === "qa") return amplitudeDeploymentKeys.qa;
  /* istanbul ignore next */
  if (trimmedPrefix === "stg") return amplitudeDeploymentKeys.stg;
  /* istanbul ignore next */
  if (trimmedPrefix === "") return amplitudeDeploymentKeys.prd;
  return "";
}

export const AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY = getAmplitudeDeploymentKey();

export const ENABLE_AMPLITUDE = isLocalEnvironment
  ? process.env.REACT_APP_ENABLE_AMPLITUDE === "true"
  : /* istanbul ignore next — deployed-env branch, covered post-replacement */
    Boolean(AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY);
